export default function ToolTip({ tip, position, children }) {
    return (
        <div className={`tooltip cursor-pointer capitalize ${position}`} data-tip={tip}>
            {children}
        </div>
    );
}
